const api = {
  version: 1
}

export default {
  api
}
